import _ from 'lodash';
import {
  INIT_ALERT,
  FLUSH_ALERT,
  END_LOADING,
  START_LOADING,
  NEW_MESSAGE,
  SET_USER_TYPING_STATUS,
  SET_MESSAGE_STATUS,
  CHECK_SCREEN_WIDTH,
  SOCKET_ERROR,
  LOADING_MESSAGE,
} from './types';

export default {
  [INIT_ALERT]: (state, payload) => {
    state.alert = {
      message: payload.message,
      type: payload.type,
      data: payload.data,
    };
  },
  [FLUSH_ALERT]: (state) => {
    state.alert = {
      message: null,
      type: null,
      data: null,
    };
  },
  [START_LOADING]: (state) => {
    state.loading = true;
  },
  [END_LOADING]: (state) => {
    state.loading = false;
  },
  [SOCKET_ERROR]: (state, error) => {
    state.socketError = error;
  },
  [NEW_MESSAGE]: (state, message) => {
    const currentRoomId = state.messages.currentChatRoomId;

    if (Number(currentRoomId) === Number(message.chat_room_id)) {
      state.messages.currentConversation.push(message);
    }

    const msgIndex = state.messages.chatRooms.findIndex(el => el.chat_room_id === message.chat_room_id);
    if (msgIndex !== -1) {
      state.messages.chatRooms[msgIndex].messages = [message];
      if (_.get(message, 'user_id') !== _.get(state, 'user.userInfo.user.id')) {
        state.messages.chatRooms[msgIndex].unread_messages_count += 1;
        state.messages.unreadMessagesCount += 1;
      }
    }
  },
  [SET_USER_TYPING_STATUS]: (state, data) => {
    state.messages.userTypingData = data;
  },
  [SET_MESSAGE_STATUS]: (state, message) => {
    const msgIndex = state.messages.chatRooms.findIndex(el => el.chat_room_id === message.chat_room_id);
    if (msgIndex !== -1) {
      state.messages.chatRooms[msgIndex].unread_messages_count = message.unread_messages_count;
    }
  },
  [CHECK_SCREEN_WIDTH]: (state, size) => {
    state.isMobileScreen = size < 1025;
  },
  [LOADING_MESSAGE]: (state, message) => {
    state.loadingMessage = message;
  }
};
